import Vuex from 'vuex'

KCVS.Stores.InformativeFieldsStore = new Vuex.Store
  state:
    informativeFields: {}
    filterValue: ''